import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/contact")({
  head: ({ params }) => ({
    meta: [
      { title: "Contact — MadCaptains" },
      { property: "og:url", content: `/${params.lang}/contact` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/contact` }],
  }),
  component: ContactPage,
});

function ContactPage() {
  const { t } = useI18n();
  return (
    <PageShell eyebrow="Editors" title={t.page_contact_h1} lead={t.page_contact_lead}>
      <p className="rounded-sm border border-dashed border-border bg-card/30 p-6 text-sm italic text-muted-foreground">
        {t.page_contact_body}
      </p>
    </PageShell>
  );
}